import { gql } from '@apollo/client'

const LOGIN_MUTATION = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input)
  }
`

export default LOGIN_MUTATION
